export default __webpack_public_path__ + "static/media/151-up.9b539ac2.png";